import script from "./DisplayScreens.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayScreens.vue?vue&type=script&setup=true&lang=js"

import "./DisplayScreens.vue?vue&type=style&index=0&id=5c166ba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c166ba2"]])

export default __exports__